<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Terms"
    :submit="submit"
    :status="status"
    :canUpdateDelete="false"
    :breadcrumbs="[
        {
          text: 'Finanzas',
          disabled: false,
          href: '/admin/liquidations'
        },
        {
          text: '...',
          disabled: false,
          href: '#'
        },
        {
          text: 'Pedidos de liquidación',
          disabled: true,
          href: '#'
        }
      ]"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row no-gutters justify="center">
        <v-col cols="8">
          <v-row no-gutters>
            <v-col>
              <ValidationProvider
                ref="name"
                rules="required"
                v-slot="{ errors }"
                
              >
                <div class="label-base pb-1">Nombre</div>
                <v-text-field
                  solo
                  hide-details="auto"
                  class="input-base"
                  :error-messages="errors"
                  v-model="data.name"
                  label="Nombre"
                />
              </ValidationProvider>
              <ValidationProvider
              
                ref="pesos_quantity"
                rules="required|numberpositivo"
                v-slot="{ errors }"
              >
                <div class="label-base pb-1 mt-2">Cantidad de pesos</div>
                <v-text-field
                  solo
                  hide-details="auto"
                  class="input-base"
                  :error-messages="errors"
                  v-model="data.pesos_quantity"
                  label="Cantidad de pesos"
                  type="Number"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider
                ref="pesos_quantity"
                rules="required|numberpositivo"
                v-slot="{ errors }"
              >
                <div class="label-base pb-1 mt-2">Cantidad de coins</div>
                <v-text-field
                  solo
                  hide-details="auto"
                  class="input-base"
                  :error-messages="errors"
                  v-model="data.coins_quantity"
                  label="Cantidad de coins"
                  type="Number"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider ref="cbu_alias" rules="" v-slot="{ errors }">
                <div class="label-base pb-1 mt-2">CBU alias</div>
                <v-text-field
                  solo
                  hide-details="auto"
                  class="input-base"
                  :error-messages="errors"
                  v-model="data.cbu_alias"
                  label="CBU alias"
                />
              </ValidationProvider>
              <ValidationProvider
                ref="status"
                rules="required"
                v-slot="{ errors }"
              >
                <div class="label-base pb-1 mt-2">Status</div>
                <v-select
                  :error-messages="errors"
                  v-model="data.status"
                  :items="items_status"
                  item-text="text"
                  item-value="id"
                  label="Status"
                  solo
                  hide-details="auto"
                  class="input-base"
                  append-icon="$caretDownFormIcon"
                ></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

extend("numberpositivo", {
  validate: (value) => {
    return value > 0;
  },
  message: "El campo debe ser mayor a 0.",
});

export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, Upload, ValidationObserver },
  data() {
    return {
      storeName: "Request_extraction",
      title: "Pedidos de Liquidación",
      data: {
        name: "",
        pesos_quantity: "",
        coins_quantity: "",
        cbu_alias: "",
        status: "",
      },
      items_status: [
        { id: "pending", text: "Pendiente" },
        { id: "paid", text: "Pagado" },
      ],
    };
  },
  computed: {
    ...mapState({
      status: (state) => state.Request_extraction.status,
    }),
  },
  async created() {
    this.loadCreated();
    /* const self = this;

        if (this.$route.params.id) {
            await self.$store.dispatch('Request_extraction/show', this.$route.params.id).then(val => {
                if (val.status) {
                    self.data.status = val.status
                }
            });
        } */
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      async handler(newId, oldId) {
        if (newId && newId !== oldId) {
          Object.assign(this.$data, this.$options.data.call(this));
          this.loadCreatedGlobal();
          this.loadCreated();
        }
      },
    },
  },
  methods: {
    async loadCreated() {
      const self = this;

      if (this.$route.params.id) {
        await self.$store
          .dispatch("Request_extraction/show", this.$route.params.id)
          .then((val) => {
            if (val.status) {
              self.data.status = val.status;
            }
          });
      }
    },
  },
};
</script>
